/**
 *
 * Footer
 *
 */

import Container from '@material-ui/core/Container';
import React from 'react';
import { NavLink } from 'react-router-dom';
import colorStrokeLong from '../images/Color-stroke-long.png';
import definixBlackLogo from '../images/definix-black-logo.png';
import facebookNormal from '../images/Footer-Icon/Facebook-Normal.png';
import githubNormal from '../images/Footer-Icon/Github-Normal.png';
import kakaoNormal from '../images/Footer-Icon/Kakao-Normal.png';
import poweredbySIX from '../images/Footer-Icon/Powered-by-SIX.png';
import redditNormal from '../images/Footer-Icon/Reddit-Normal.png';
import telegramNormal from '../images/Footer-Icon/Telegram-Normal.png';
import twitterNormal from '../images/Footer-Icon/Twitter-Normal.png';

function Footer() {
  return (
    <footer>
      <img src={colorStrokeLong} alt="" className="color-stroke large" />
      <Container>
        <div className="flex align-center flex-wrap justify-center">
          <NavLink to="/">
            <img src={definixBlackLogo} alt="" className="logo mr-4" />
          </NavLink>
          <p className="mt-2 mx-4">Advance your crypto assets</p>
          <a
            href="https://coinmarketcap.com/currencies/six/markets/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={poweredbySIX} alt="" className="six-logo" />
          </a>
        </div>

        <div className="social">
          <a
            href="https://www.facebook.com/thesixnetwork"
            target="_blank"
            rel="noreferrer"
          >
            <img src={facebookNormal} alt="" />
          </a>
          <a
            href="https://twitter.com/DefinixOfficial"
            target="_blank"
            rel="noreferrer"
          >
            <img src={twitterNormal} alt="" />
          </a>
          <a href="https://t.me/SIXNetwork" target="_blank" rel="noreferrer">
            <img src={telegramNormal} alt="" />
          </a>
          <a
            href="https://open.kakao.com/o/gsh5pWGd"
            target="_blank"
            rel="noreferrer"
          >
            <img src={kakaoNormal} alt="" />
          </a>
          <a
            href="https://github.com/thesixnetwork"
            target="_blank"
            rel="noreferrer"
          >
            <img src={githubNormal} alt="" />
          </a>
          <a
            href="https://www.reddit.com/r/sixnetwork/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={redditNormal} alt="" />
          </a>
        </div>
      </Container>
    </footer>
  );
}

Footer.propTypes = {};

export default Footer;
